module.exports = __webpack_public_path__ + "img/S_ok.baff247c.png";